import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-section',
  templateUrl: './activity-section.component.html',
  styleUrls: ['./activity-section.component.scss']
})
export class ActivitySectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
